import moment from "moment";
export const ordersListHeaderInfo = {
    generalInfo: ["Օգտատեր", "Հեռախոս", "Գին", "Պատվերի համար", "Ամսաթիվ"],
    status: true,
    largeItems: [],
};

export function ordersDataParser(ordersList, ) {
    let itemListInfo = [];
    ordersList.itemsList.forEach(item => {
        const name = item?.user ? (item?.user?.firstName + " " + item?.user?.lastName) : item?.name;

        itemListInfo.push({
            id: item.id,
            status: {
                title: item?.status?.title || '',
                color: item?.status?.color || '',
            },
            newItem: !(item?.seen ?? true),
            values: [
                name || "",
                item?.phoneNumber || item?.username,
                item?.products.reduce((sum, item)=>{return sum + item.price * item.purchasedQuantity},0) + " Դրամ",
                item.orderNumber || "-",
                moment(item.createdAt).format('DD.MM.YYYY HH:mm'),
            ],
        });
    });
    return itemListInfo;
}
